import { render, staticRenderFns } from "./simlist.vue?vue&type=template&id=5271ceee&scoped=true"
import script from "./simlist.vue?vue&type=script&lang=js"
export * from "./simlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271ceee",
  null
  
)

export default component.exports